import { Toast } from './models/toast';
import { Injectable, signal } from '@angular/core';

const DEFAULT_CONFIG: Toast = {
  type: 'primary',
  title: '',
  closable: true,
  content: '',
  autohide: true,
  delay: 5_000,
};

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly config = signal<Partial<Toast>>(DEFAULT_CONFIG);

  toasts = signal<Toast[]>([]);

  add(toast: Partial<Toast>) {
    this.toasts.set([
      ...this.toasts(),
      { ...DEFAULT_CONFIG, ...this.config(), ...toast },
    ]);
  }

  remove(toast: Toast) {
    this.toasts.set(this.toasts().filter((t) => t !== toast));
  }
}
